import { authFetch } from "./client";

export const accountTransactionKeys = {
  all: ["account-transactions"],
  list: (page) => ["account-transactions", "list", { page }],
};

export const ekedcMonthlyReportKeys = {
  all: ["ekedc-monthly-report"],
};

export const fetchAccountTransactions = ({ page = 1 } = {}) =>
  authFetch(`admin/account-transactions?page=${page}`);

export const fetchEkedcMonthlyReport = () =>
  authFetch("admin/ekedc-monthly-report");
